<template>
  <div>
    <div class="main">
      <img
        class="img-not-found uk-flex uk-flex-wrap"
        src="../assets/img/WorkInProgress.png"

        alt=""
      >
      <br>
      <div
        v-if="false"
        class="title uk-text-center"
      >
        <h2>Pagina en Progreso!!!</h2>
        <h4>Lo siento, estamos optimizando el sitio web para brindarle un mejor servicio</h4>
        <button
          class="uk-button uk-margin"
          @click="goHome"
        >
          Regrese a pagina inicial
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goHome () {
      this.$router.push({ name: 'Home' })
    }
  }

}
</script>

<style scoped>
.img-not-found{
  width: 40%;
  margin: auto;
  max-width: 600px;
}
.title h2{
  font-weight: 600;
  color: #002c3f;
}

.title h4{
  margin: 0px;
  color: #002c3f;

}
.container{
  height: 443px;
}

.main{
  margin: auto;
}

</style>
